<template>
	<div id="no-auth-app" v-show="isLoading">
		<a href="javascript:;" class="no-auth-logo"><img src="../assets/logo.png" alt="无端科技"></a>
		<div id="header">
			<ul>
			<li class="header-games subs">
				<b>{{$t("header.GameLists")}}</b>
				<div class="sub-content games-content">
				<a :href="game.link[$i18n.locale] || game.link.default" v-for="(game,idx) in games" :key="'app-game-'+idx">{{game.name[$i18n.locale]}}</a>
				</div>
			</li>
			
			<li class="header-link">
				<a :href="'http://www.wooduan.com/service?lang='+($i18n.locale=='zh'?'zh':'en')" target="_blank">{{$t('header.CustomerServiceCenter')}}</a> 
			</li>
			<li class="header-lans subs">
				<b>{{$t('header.Language')}}</b>
				<div class="sub-content lans-content">
				<a href="javascript:;" @click="setLanguage(lan.key)" v-for="(lan,idx) in base_configs.languages" :key="idx">{{lan.name}}</a>
				</div>
			</li>
			</ul>
		</div>
		<div class="video banner"></div>
		<div class="footer">
			<template v-if="$i18n.locale=='zh'">
				<div class="foot-list">版权所有 - 浙江无端科技股份有限公司 <img class="beian" src="https://rescdn.ssjj.cn/assets/image/common/beian.png" /><a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010602012073" target="_blank">浙公网安备 33010602012073号</a><a href="http://beian.miit.gov.cn/" target="_blank"> 浙ICP备12045629号-9</a></div>
				<div class="foot-list">审批文号：国新出审[2020]929号｜网络游戏出版物ISBN号：ISBN978-7-498-07683-0</div>
				<div class="foot-list">抵制不良游戏 拒绝盗版游戏 注意自我保护 谨防受骗上当 适度游戏益脑 沉迷游戏伤身 合理安排时间 享受健康生活</div>
			</template>
			<template v-else>
				<div class="foot-list">COPYRIGHT © WIZARDGAMES. ALL RIGHTS RESERVED</div>
			</template> 
		</div>

		<div id="login" class="no-auth-dialog" v-if="type == 'login'">
			<h2>{{$t('login.Login')}}</h2>
			<div class="input-div">
				<input type="text" v-model="login.account" :placeholder="$t('login.AccountLabel')">
			</div>
			<div class="input-div">
				<input type="password" v-model="login.password" @keyup.enter="loginSubmit" :placeholder="$t('login.PasswordLabel')">
			</div>
			<div class="remember-account">
				<input type="checkbox" name="savePassword" id="savepass" v-model="isSave">
				<div class="sub-checkbox"></div>
				<span>记住我的登录信息</span>
			</div>
			<div class="btn-div">
				<wd-button type="danger" @click.native="loginSubmit" size="large" :styles="{width:'100%'}">{{$t('login.LoginBtn')}}</wd-button>
			</div>
			<div class="text-div">
				<a href="javascript:;" class="reg-link" @click="type = 'reg'">{{$t('login.RegisterLink')}}</a>
				<a href="javascript:;" class="forgot-link" @click="type = 'forgot'">{{$t('login.ForgotLink')}}</a>
			</div>

			<div class="third-login" v-if="base_configs">
				<b>{{$t('login.QuickLogin')}}</b>
				
				<div style="position:relative">
					<!-- <span id="wb_connect_btn" class="weibo_btn">微博登录按钮</span> -->
					<a href="javascript:;" @click="$thirdLogin(th)" v-for="(th,idx) in base_configs.third_login_types" :key="idx"><img :src="'/img/login-'+th+'.png'" alt=""></a>
				</div>
			</div>
		</div>
	
		<div id="reg" class="no-auth-dialog" v-else-if="type=='reg'">
			<h2>{{$t('login.Register')}}</h2>
			<div class="input-div">
				<input type="text" v-model="reg.account"  :placeholder="$t('login.UserName')">
			</div>
			<div class="input-div">
				<input type="password" v-model="reg.password" :placeholder="$t('login.PasswordLabel')">
			</div>
			<div class="input-div">
				<input type="password" v-model="reg.confirm_password" :placeholder="$t('login.ConfirmPasswordLabel')">
			</div>
			<!-- 手机号，邮箱是否需要 -->
			<template v-if="base_configs.reg_config.phone || base_configs.reg_config.email">
				<div class="input-div" v-if="base_configs.reg_config.email">
					<input type="text" v-model="reg.email"  :placeholder="$t('email.Email')">
				</div>
				<div class="input-div" v-if="base_configs.reg_config.phone">
					<input type="text" v-model="reg.phone"  :placeholder="$t('phone.MobilePhoneNumber')">
				</div>
				<div class="input-div">
					<input type="text" v-model="reg.code" @keyup.enter="regSubmit"  :placeholder="base_configs.reg_config.phone?$t('default.MessageAuthenticationCode'):$t('default.EmailAuthenticationCode')" class="code-input">
					<span class="code-btn">
						<wd-button 
							ref="reg-code-btn"
							@click.native="base_configs.reg_config.phone?sendMessageCode('reg'):sendEmailCode('reg')"
							type="info" 
							size="small" 
							:styles="{height:'44px',padding:'5px 15px'}"
							>{{$t('default.SendVerificationCode')}}</wd-button>
					</span>
				</div>
			</template>
			
			<div class="btn-div">
				<wd-button type="danger" @click.native="regSubmit" size="large" :styles="{width:'100%'}">{{$t('login.RegisterBtn')}}</wd-button>
			</div>
			<div class="text-div">
				<a href="javascript:;" class="login-link" @click="type = 'login'">{{$t('login.LoginLink')}}</a>
			</div>
		</div>
		<div v-else-if="type=='forgot'">
			<div id="forgot" class="no-auth-dialog" v-if="forgotType==''">
				<h2>{{$t('forgot.RecoverPassword')}}</h2>
				<p>{{$t('forgot.RecoverPasswordTip')}}</p>
				<div class="forgot-div" @click="forgotType='phone'" v-if="base_configs.used_phone_reg">
					<span><img src="../assets/home-security-3.png" alt=""></span>
					<b>{{$t('forgot.SecurityMobilePhone')}}</b>
				</div>
				<div class="forgot-div" @click="forgotType='email'">
					<span><img src="../assets/home-security-4.png" alt=""></span>
					<b>{{$t('forgot.SecurityEmail')}}</b>
				</div>
				<div class="forgot-div" @click="questionClick">
					<span><img src="../assets/home-security-5.png" alt=""></span>
					<b>{{$t('forgot.SecurityQuestion')}}</b>
				</div>
				<div class="text-div" style="margin-top: 30px">
					<a href="javascript:;" class="reg-link" @click="forgotType = 'complaint'">{{$t('nav.AccountComplaint')}}</a>
					<a href="javascript:;" class="forgot-link" @click="type = 'login'">{{$t('login.LoginLink')}}</a>
				</div>
			</div>
			
			<div class="forgot-form no-auth-dialog" v-else-if="forgotType == 'complaint'">
				<h2>{{$t('nav.AccountComplaint')}}</h2>
				<div class="complaint-div">
					{{$t("complaint.ComplaintCon")}}
				</div>
				<div class="text-div" style="margin-top: 30px">
					<a href="javascript:;" class="login-link" @click="switchForget">{{$t('forgot.RecoverPassword')}}</a>
				</div>
			</div>

			<div class="forgot-form no-auth-dialog" v-else-if="forgotType == 'phone'">
				<h2>{{$t('login.RecoverByPhone')}}</h2>
				<div class="input-div">
					<input type="text" v-model="forgot.phone"  :placeholder="$t('login.Phone')">
				</div>
				<div class="input-div">
					<input type="text" v-model="forgot.messageCode"  :placeholder="$t('default.MessageAuthenticationCode')" class="code-input">
					<span class="code-btn">
							<wd-button 
								ref="forgot-code-btn"
								@click.native="sendMessageCode('forgot')"
								type="info" 
								size="small" 
								:styles="{height:'44px',padding:'5px 15px'}"
								>{{$t('default.SendVerificationCode')}}</wd-button>
						</span>
				</div>
				<div class="input-div">
					<input type="password" v-model="forgot.password" :placeholder="$t('login.PasswordLabel')">
				</div>
				<div class="input-div">
					<input type="password" v-model="forgot.confirmPassword" @keyup.enter="forgotSubmit" :placeholder="$t('login.ConfirmPassword')">
				</div>
				<div class="btn-div">
					<wd-button type="danger" @click.native="forgotSubmit" size="large" :styles="{width:'100%'}">{{$t('login.ResetPassword')}}</wd-button>
				</div>
				<div class="text-div" style="margin-top: 30px">
					<a href="javascript:;" class="login-link" @click="switchForget">{{$t('login.RecoverByOther')}}</a>
				</div>
			</div>

			<div class="forgot-form no-auth-dialog" v-else-if="forgotType == 'email'">
				<h2>{{$t('login.RecoverByEmail')}}</h2>
				<!-- <div class="input-div">
					<input type="text" v-model="forgot.account"  :placeholder="$t('login.UserName')">
				</div> -->
				<div class="input-div">
					<input type="text" v-model="forgot.email"  :placeholder="$t('login.SecurityEmail')">
				</div>
				<div class="input-div">
					<input type="text" v-model="forgot.emailCode"  :placeholder="$t('default.EmailAuthenticationCode')" class="code-input">
					<span class="code-btn">
							<wd-button 
								ref="forgot-email-code-btn"
								@click.native="sendEmailCode('forgot')"
								type="info" 
								size="small" 
								:styles="{height:'44px',padding:'5px 15px'}"
								>{{$t('default.SendVerificationCode')}}</wd-button>
						</span>
				</div>
				<div class="input-div">
					<input type="password" v-model="forgot.password" :placeholder="$t('login.PasswordLabel')">
				</div>
				<div class="input-div">
					<input type="password" v-model="forgot.confirmPassword" @keyup.enter="forgotSubmit" :placeholder="$t('login.ConfirmPassword')">
				</div>
				<div class="btn-div">
					<wd-button type="danger" @click.native="forgotSubmit" size="large" :styles="{width:'100%'}">{{$t('login.ResetPassword')}}</wd-button>
				</div>
				<div class="text-div" style="margin-top: 30px">
					<a href="javascript:;" class="login-link" @click="switchForget">{{$t('login.RecoverByOther')}}</a>
				</div>
			</div>

			<div class="forgot-form no-auth-dialog" v-else-if="forgotType == 'question'">
				<h2>{{$t('login.RecoverByQuestion')}}</h2>
				<div class="input-div">
					<input type="text" v-model="forgot.account"  :placeholder="$t('login.UserName')">
				</div>
				<div class="input-div">
					<span class="place_text" v-if="question_id == 0">{{$t('login.SecurityQuestion')}}</span>
					<!-- <input type="text" v-model="forgot.question"  :placeholder="$t('login.SecurityQuestion')"> -->
					<select name="" id="" v-model="question_id">
						<option 
							:selected="question_id == q.id"				
							:value="q.id" 
							v-for="(q,idx) in activeQuestion" 
							:key="'q-opt-'+idx">{{q.question}}</option>
					</select>
				</div>
				<div class="input-div">
					<input type="text" v-model="forgot.answer"  :placeholder="$t('login.SecurityAnswer')">
				</div>
				
				<div class="input-div">
					<input type="password" v-model="forgot.password" :placeholder="$t('login.PasswordLabel')">
				</div>
				<div class="input-div">
					<input type="password" v-model="forgot.confirmPassword" @keyup.enter="forgotSubmit" :placeholder="$t('login.ConfirmPassword')">
				</div>
				<div class="btn-div">
					<wd-button type="danger" @click.native="forgotSubmit" size="large" :styles="{width:'100%'}">{{$t('login.ResetPassword')}}</wd-button>
				</div>
				<div class="text-div" style="margin-top: 30px">
					<a href="javascript:;" class="login-link" @click="switchForget">{{$t('login.RecoverByOther')}}</a>
				</div>
			</div>

		</div>
	</div>
</template>
<script>
	import WdButton from '@/components/WdButton.vue';
	import VerificationCode from '@/components/VerificationCode.vue';
	import secret from '@/utils/secret.js'
	export default{
		name:"",
		data(){
			return {
				type:'login',
				forgotType:'',
				login:{
					account:'',
					password:'',
				},
				isSave:false,
				reg:{
					account:'',
					password:'',
					confirm_password:'',
					phone:'',
					email:'',
					code:'',
				},
				forgot:{
					account:'',
					phone:'',
					messageCode:'',
					emailCode:'',
					password:'',
					confirmPassword:'',
					question:'',
					answer:''
				},
				lang:'zh',
				thirdLoginCallBack:escape(window.location.href),
				questions:[],
				question_id:0,
				base_configs:{},
				games:[],
				channel:1,//1官网2顺网3云更新,http://confluence.wd.com/pages/viewpage.action?pageId=32906205
				sub_channel:4096,
				isLoading:false,
			}
		},
		components:{
			'wd-button':WdButton,
			'v-code':VerificationCode
		},
		computed: {
	        isRegPhone(){
	       	 if(!this.base_configs.used_phone_reg) return false;
			 if(!/^[0-9]{3,30}$/.test(this.reg.account)) return false;
			 return true;
		    },
		    isRegEamil(){
				return /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/.test(this.reg.email);
			},
		   loginPhone(){
			   let regPhone = /^1[3|4|5|6|7|8|9][0-9]{9}$/;
			   if(!regPhone.test(this.login.account)) return false;
			   return true;
		   },
		    regPhone(){
			 	return /^1[3|4|5|6|7|8|9][0-9]{9}$/.test(this.reg.phone);
		   },
		   passwordRex(){//至少包含数字和字母，可选部分特殊字符，6-16位
			   return /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z!@#$%^&*-_]{6,16}$/.test(this.reg.password);
		   },
		   activeQuestion(){
				return this.arrFilter();
			},
		   accountReg(){//用户名正则 英文字母开头,不含中文，4-18位
			   return /^[a-zA-Z][a-zA-Z0-9]{3,17}$/.test(this.reg.account);
		   }
	    },
		methods:{
			async loginSubmit(){
				this.lang = this.$i18n.locale;
				if(!this.login.account){
					this.$alert(this.$t('login.PhoneAccountTip'));
					return;
				}
				if(!this.login.password){
					this.$alert(this.$t('login.PasswordTip'));
					return;
				}

				let loginType = 1;
				let postData = {};
				if(!/^[0-9]{3,30}$/.test(this.login.account)){
					if(this.isEmail(this.login.account)){
						loginType = 4;
						postData = {
							type:loginType,
							email:this.login.account,
							password:this.login.password
						}
					}else{
						loginType = 2;
						postData = {
							type:loginType,
							account:this.login.account,
							password:this.login.password
						}
					}
					
				}else{
					if(this.lang == 'zh' && !this.loginPhone){
						this.$alert('手机号格式不正确');
						return;
					}
					postData = {
						type:loginType,
						phone:this.login.account,
						password:this.login.password
					}
				}
				if(this.isSave){
					localStorage.setItem('username',this.login.account);
					localStorage.setItem('password',secret.encrypt(this.login.password));
					localStorage.setItem('isSave',true)
				}else{
					localStorage.removeItem('username');
					localStorage.removeItem('password');
					localStorage.removeItem('isSave');
				}

				let response = await this.$api.post('/web/basic/login',postData);
				if(response.code == 0){
					this.$api.setAuthToken(response.data.user_token);
					this.$router.replace({name: 'user',query: {from: this.from}});
				}else if(response.code == 420016){
					this.$alert(this.$t('login.PhoneNotReged'));
				}else if(response.code == 420001){
					this.$alert(this.$t('login.AccountNotReged'));
				}else if(response.code == 420020){
					this.$alert(this.$t('default.PasswordError'));
				}else if(response.code == 10001){
					this.$alert(this.$t('default.PasswordError'));
				}else{
					this.$alert(this.$t('login.LoginFail'))
				}
			},
			async regSubmit(){	
				this.lang = this.$i18n.locale;
				if(!this.reg.account){
					this.$alert(this.$t('login.RegAccountTip'));
					return;
				}   
				if(!this.accountReg){
					return this.$alert(this.$t('login.AccountErr'))
				}        
				if(!this.reg.password){
					this.$alert(this.$t('login.PasswordTip'));
					return;
				}
				if(this.reg.password && !this.passwordRex){
					this.$alert(this.$t('login.PasswordErr'));
					return;
				}
				if(this.reg.password != this.reg.confirm_password){
					this.$alert(this.$t('default.PasswordsNotMatch'));
					return;
				}
				let postData = {
						account:this.reg.account,
						password:this.reg.password,
						confirm_password:this.reg.confirm_password,
						channel_id:this.channel,
            			sub_channel_id:this.sub_channel
					}
				//手机号，邮箱是否需要
				if(this.base_configs.reg_config.phone || this.base_configs.reg_config.email){
					if(this.base_configs.reg_config.email){
						if(this.reg.email && !this.isRegEamil){
							this.$alert(this.$t('email.EmailFormat'));
							return;
						}
						postData.email = this.reg.email;
					}
					if(this.base_configs.reg_config.phone){
						if(!this.reg.phone){
							this.$alert(this.$t('phone.MobilePhoneNumberTip'));
							return;
						}
						if(this.lang == 'zh' && !this.regPhone ){
							this.$alert('手机号格式不正确');
							return;
						}
						postData.phone = this.reg.phone;
					}
				
					if(!this.reg.code){
						this.$alert(this.$t('default.VerificationCodeTip'));
						return;
					}
					postData.code = this.reg.code;
				}
				
				let response = await this.$api.post('/web/basic/reg',postData);
				if(response.code == 0){
					this.$api.setAuthToken(response.data.user_token);
					this.$router.replace({name: 'user',query: {from: this.from}});
				}else if(response.code == 420036){
					this.$alert(this.$t('login.PhonwHasReged'));
				}else if(response.code == 420033){
					this.$alert(this.$t('login.AccountHasReged'));
				}else if(response.code == 10003){
					this.$alert(this.$t('default.EmailCodeErr'));
				}else if(response.code == 10004){
					this.$alert(this.$t('default.ImgCodeErr'));
				}else if(response.code == 420052){
                     this.$alert(this.$t('login.EmailHasReged'))
				}else{
					this.$alert(this.$t('login.RegFail'))
				}
			},
			async forgotSubmit(){
				let postData = {
					password:this.forgot.password,
					confirm_password:this.forgot.confirmPassword,
					language:this.$i18n.locale
				}
				let patrn = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z!@#$%^&*-_]{6,16}$/;
			 	if(!postData.password) {
				   return this.$alert(this.$t('forgot.NewPasswordTip'));
			    }
			    if(!patrn.test(postData.password)) {
				   this.$alert(this.$t('login.PasswordErr'))
					return;
			    }
			    if(postData.password != postData.confirm_password){
					return this.$alert(this.$t('default.PasswordsNotMatch'));
				}

				if(this.forgotType == 'phone'){
					postData.phone = this.forgot.phone;
					postData.code = this.forgot.messageCode;
					if(!postData.code){
						return this.$alert(this.$t('default.VerificationCodeTip'));
					}
				}
				if(this.forgotType == 'email'){
					postData.email = this.forgot.email;
					postData.code = this.forgot.emailCode;
					// postData.account = this.forgot.account;
					if(!postData.code){
						return this.$alert(this.$t('default.VerificationCodeTip'));
					}
				}
				if(this.forgotType == 'question'){
					for(let i=0;i<this.activeQuestion.length;i++){
						if(this.question_id == this.activeQuestion[i].id){
							postData.security_question =  this.activeQuestion[i].question;
						}
					}
					postData.answer = this.forgot.answer;
					postData.account = this.forgot.account;
				}
			
				let response = await this.$api.post('/web/basic/getPassword',postData);
				if(response.code == 0){
					this.$alert(this.$t('default.PasswordChangeSuccess'));
					this.type = "login";
					this.switchForget();
				}else if(response.code == 420028){
					this.$alert(this.$t('forgot.SecurityAnswerError'));
				}else if(response.code == 10003){
					this.$alert(this.$t('default.EmailCodeErr'));
				}else if(response.code == 10004){
					this.$alert(this.$t('default.ImgCodeErr'));
				}else{
					this.$alert(response.msg)
				}

			},
			switchForget() {//切换密保方式
				this.forgotType = '';
				this.forgot.password = '';
				this.forgot.confirmPassword = '';
			},
			sendMessageCode(type){
				if(type == 'reg'){
					this.$refs['reg-code-btn'].sendMessageCode('reg',this.reg.phone);
				}
				if(type == 'forgot'){
					this.$refs['forgot-code-btn'].sendMessageCode('forgot',this.forgot.phone);
				}
			},
			sendEmailCode(type){
				if(type == 'reg'){
					this.$refs['reg-code-btn'].sendEmailCode(type,this.reg.email);
				}else{
					this.$refs['forgot-email-code-btn'].sendEmailCode(type,this.forgot.email);
				}	
			},
			//密保问题列表
			async getQuestions(){
				let response = await this.$api.get('/web/basic/getSecurityQuestions');
				if(response.code == 0){
					this.questions = this.questions.concat(response.data);
				}
			},
			arrFilter(){
				var arr=[];
				var lang = this.$i18n.locale;
				this.questions.forEach(function(item){
					if(item.language == lang){
						arr.push(item)
					}
				})
				return arr;
			},
			questionClick(){
				this.forgotType = 'question';
				this.getQuestions();
			},
			//邮箱验证
			isEmail(email){
				var reg = new RegExp("^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$");
				if(!reg.test(email)) return false;
				return true;
			},
			getLocalData(){
				let isSave = localStorage.getItem('isSave');
				if(isSave){
					let username = localStorage.getItem('username');
					let password = localStorage.getItem('password');
					this.login = {
						account:username,
						password:secret.decrypt(password)
					}
					this.isSave = true;
				}
			},
			setLanguage(lan){
				this.$i18n.locale = lan
				localStorage.setItem('WIZARD_MEMBER_LANGUAGE',lan);
			},
		},
		async created(){
			this.from = this.$route.query.from || '';
			let token = localStorage.getItem('WIZARD_MEMBER_TOKEN');
			if(token){
				this.$getUser();
			}else{
				this.isLoading = true;
			}
			this.$events.listen('USER-INFO',(user)=>{
				this.isLoading = true;
				if(user){
					this.$router.push({name: 'user',query: {from: this.from}});
				}
			})
			let {base_configs,games} = await this.$getAppBaseData(this.from);
			this.base_configs = base_configs;
			this.games = games;
			if(this.$route.query.token){
				this.$api.setAuthToken(this.$route.query.token);
				this.$getUser().then(res=>{
					this.$router.push({name: 'user',query: {from: this.from}});
				})
			}
			if(this.$route.query.type == 'reg' || this.$route.query.type=="forgot"){
				this.type = this.$route.query.type;
				if(this.$route.query.channel){
					this.sub_channel = this.$route.query.channel;
					if(this.sub_channel<8192){
						this.channel = 1;
					}else if(this.sub_channel<12288){
						this.channel = 2;
					}else {
						this.channel = 3;
					}
				}
			}
			this.getLocalData();
		},
		mounted(){

		}
	}
</script>
<style scoped>
	.no-auth-dialog{
		position: absolute;
		z-index: 995;
		background-color:rgba(0,0,0,.7);
		top: 100px;
		left: 50%;
		transform: translate(-50%,0%);
		padding: 50px;
		min-width: 450px;
		border-top: 5px solid #ce292c;
	}

	.no-auth-dialog h2{
		text-align: center;
		font-size: 22px;
		color: #fff;
		margin-top: 0px;
		margin-bottom: 20px;
	}
	.no-auth-dialog p{
		width: 450px;
		color: #fff
	}
	.no-auth-dialog>div{
		margin-bottom: 15px;
	}
	.no-auth-dialog .input-div{
		width: 100%;
		height: 44px;
		display: flex;
		position: relative;
	}
	.no-auth-dialog .input-div input{
		background-color: transparent;
		border:1px solid #595b5f;
		border-radius: 5px;
		outline: none;
		width: 100%;
		box-sizing: border-box;
		padding: 0 15px;
		color: #d7d9d8;
		height: 42px;
	}
	.no-auth-dialog .input-div input:focus{
		border: 1px solid #868887;
	}
	.no-auth-dialog .input-div select{
		background-color: transparent;
		border:1px solid #595b5f;
		border-radius: 5px;
		outline: none;
		width: 100%;
		box-sizing: border-box;
		padding: 0 15px;
		color: #d7d9d8
	}
	.no-auth-dialog .input-div select option{
		color: #333;
	}
	.no-auth-dialog .input-div .place_text{
		position: absolute;
		top: 0;
		height: 44px;
		line-height: 44px;
		left: 10px;
		z-index: 3;
		color: grey;
		font-size: 14px;
	}
	.no-auth-dialog .complaint-div{
		width: 450px;
		color: #fff;
		font-size: 14px;
		line-height: 25px;
	}
	.text-div{
		height: 20px;
		line-height: 20px;
	}
	.text-div a{
		color: #b1b1b1;
		font-size: 14px;
	}
	.reg-link{
		float: left;
	}
	.forgot-link{
		float: right;
	}
	.login-link{
		display: block;
		text-align: center;
	}
	.code-btn{
		margin-left: 10px;
	}
	.code-input{
		flex: 1
	}

	.no-auth-dialog .forgot-div{
		height: 50px;
		margin-top: 15px;
		border-bottom: 1px solid #595b5f;
		position: relative;
		padding-left: 60px;
		cursor: pointer;
	}
	.no-auth-dialog .forgot-div span{
		display: inline-block;
		width: 40px;
		height: 40px;
		border-radius: 50%;
		background-color: #1f2022;
		text-align: center;
		line-height: 40px;
		position: absolute;
		left: 0;
		top: 5px;
	}
	.no-auth-dialog .forgot-div span img{
		width: 20px;
		padding: 10px;
	}
	.no-auth-dialog .forgot-div b{
		color: #fff;
		display: block;
		line-height: 50px;
	}

	.no-auth-dialog .forgot-div:hover b{
		color:#c72729;
	}
	.no-auth-dialog .forgot-div:hover span{
		background-color: #c72729;
	}
	.third-login{
		margin-top: 40px;
		color: #fff;
	}
	.third-login b{
		display: block;
		text-align: center;
	}
	.third-login div{
		margin-top: 30px;
		display: flex;
		justify-content: center;
		position: relative;
	}
	.third-login div a{
		width: 60px;
		height: 60px;
		overflow: hidden;
		border-radius: 50%;
		background-color: #2a2b2c;
		text-align: center;
		line-height: 60px;
		padding: 10px;
		margin: 0 15px;
		box-sizing: border-box;
		display: inline-block;
	}
	.third-login div a img{
		width: 40px;
		height: 40px;
		opacity: 0.6

	}
	.remember-account {
		position: relative;  /*父层*/
		color: #b1b1b1;
		font-size: 14px;margin-bottom: 15px;margin-top:-10px
	}
	.remember-account input[type="checkbox"] {
		position: absolute;  /*input,相对定位*/
		-webkit-appearance: none;
		outline: none;
		border: none;
		background-color: transparent;
		box-sizing: border-box;
		height: 14px;
		width: 14px;
		cursor: pointer;
		border: 1px solid #3e3e3e;
		box-sizing: border-box;
		vertical-align: middle;
		opacity: 0; /*透明度为0，隐藏掉input*/
		z-index: 2; /* 比input下面的div,z-index:1大，层叠在最上面，点击时候能点击到input */
		top:5px;
		
	}
	/*用div模拟input的样式*/
	.sub-checkbox{
		display: inline-block;
		position: absolute; /*input下面的div,相对定位*/
		-webkit-appearance: none;
		outline: none;
		border: none;
		background-color: transparent;
		box-sizing: border-box;
		height: 14px;
		width: 14px;
		cursor: pointer;
		border: 1px solid #3e3e3e;
		box-sizing: border-box;
		vertical-align: middle;
		z-index: 1;/* 比input的z-index:2小，层叠在下面面 */
		top:5px;
	}
	/*!!利用伪类的写法+；input选中后，下面的div的样式*/
	input[type="checkbox"]:checked + div {
		height: 14px;
		width: 14px;
		background-image: url(../assets/check.png);
		background-repeat: no-repeat;
		background-position: 0 0;
		vertical-align: middle;
		border: none;
	}
	.remember-account span{
		display: inline-block;
		vertical-align: middle;
		margin-left: 20px;/*因为input和它下面的div都相对定位脱离了文本流，所以不给距离，文字会层叠过去*/
	}
</style>